import { ApiFilter } from './api-filter.interface';

export interface ApiQuery {
  perPage?: number;
  page?: number;
  // sortDir?: 'asc' | 'desc';
  // sortBy?: string;
  filters?: string | ApiFilter;
  search?: string;
  sort?: string[];
  fields?: string[];
  [key: string]: any;
}

export const apiQueryHash = (query?: ApiQuery | null): string => {
  const sortedKeys = Object.keys(query || {}).sort();
  const queryStr = sortedKeys
    .filter((key) => query?.[key] !== undefined)
    .map((key) => {
      const value = query?.[key];
      if (Array.isArray(value)) {
        return `${key}=${value.sort().join(',')}`;
      } else if (typeof value === 'object' && value !== null) {
        if (key === 'filters') {
          return `${key}=${value.toString()}`;
        } else {
          return `${key}=${JSON.stringify(value)}`;
        }
      } else {
        return `${key}=${value}`;
      }
    })
    .join('&');

  // Create simple hash
  let hash = 0;
  for (let i = 0; i < queryStr.length; i++) {
    const char = queryStr.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }

  const result = ('00000000' + (hash >>> 0).toString(16))
    .slice(-8)
    .repeat(4)
    .slice(0, 32);

  return result;
};
